<app-button-toggle-control
    (valueChange)="emit_valueChange($event)"
    [appearance]="input_appearance$$()"
    [control]="control$$()"
    [framed]="input_framed$$()"
    [hint]="input_hint$$()"
    [hintAlign]="input_hintAlign$$()"
    [hideSingleSelectionIndicator]="input_hideSingleSelectionIndicator$$()"
    [label]="label$$()"
    [list]="input_list$$()"
    [readonly]="readonly$$()"
    [vertical]="input_vertical$$()"
/>
